"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TextInput as MantineTextInput, factory, useProps, } from "@mantine/core";
import "@mantine/core/styles/Input.layer.css";
import * as styles from "./TextInput.module.css";
const TextInput = factory(({ optionalText = "Optional", ...props }, ref) => {
    const modifiedProps = useProps("TextInput", {
        classNames: styles,
        inputWrapperOrder: ["label", "input", "description", "error"],
        size: "md",
        withAsterisk: false,
    }, props);
    // Should only render if `required` is false, not if it is undefined/null/true
    const isOptional = modifiedProps.required === false;
    return (_jsx(MantineTextInput, { ...modifiedProps, label: modifiedProps.label && (_jsxs(_Fragment, { children: [modifiedProps.label, isOptional && (_jsx("span", { className: styles.optional, children: optionalText }))] })), ref: ref }));
});
TextInput.displayName = "TextInput";
export { TextInput };
//# sourceMappingURL=TextInput.js.map